<template>
	<div class="comment-box">
    <div class="comment-block">
      <div class="comment-item">
        <div class="speaker">{{$store.state.current_comment.speaker}}:</div>
        <p>{{$store.state.current_comment.content}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default{
	name: 'comment'
}
</script>


// WEBPACK FOOTER //
// src/components/Comment.vue